import { labelByValue, TabsValue } from '../constants/tabs';

export const getCampaignsListTabs = ({
  recruitmentCount,
  otherCount
}: {
  recruitmentCount: number;
  otherCount: number;
}) => [
  {
    label: labelByValue[TabsValue.RECRUITMENT],
    value: TabsValue.RECRUITMENT,
    count: recruitmentCount
  },
  {
    label: labelByValue[TabsValue.OTHER],
    value: TabsValue.OTHER,
    count: otherCount
  }
];
